const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  language: state => state.user.language,
  loginDialogVisible: state => state.user.loginDialogVisible,
  startedDialogVisible: state => state.user.startedDialogVisible,
  createSuccessVisible: state => state.user.createSuccessVisible,
  chatDialogVisible: state => state.user.chatDialogVisible,
  socket: state => state.user.socket,
  config: state => state.user.config
}
export default getters
